import React from 'react';

const SidebarIcon = ({ type }) => {
  if (type === 'incidents') {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M9 11l3 3L22 4"/>
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
      </svg>
    );
  }

  if (type === 'thresholds') {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 3v18" />
        <path d="M5 8h4" />
        <path d="M15 16h4" />
        <circle cx="9" cy="8" r="2" />
        <circle cx="15" cy="16" r="2" />
      </svg>
    );
  }

  if (type === 'alerts') {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M15 17h5l-1.4-1.4a2 2 0 0 1-.6-1.4V11a6 6 0 1 0-12 0v3.2a2 2 0 0 1-.6 1.4L4 17h5" />
        <path d="M10 17a2 2 0 0 0 4 0" />
      </svg>
    );
  }

  if (type === 'texcumar') {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 18h18" />
        <path d="M5 15l4-5 3 3 5-7 2 3" />
        <circle cx="9" cy="10" r="1" />
        <circle cx="12" cy="13" r="1" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 3v18h18" />
      <path d="M7 14l4-4 3 3 4-6" />
    </svg>
  );
};

/**
 * Sidebar navigation component
 */
export const Sidebar = ({
  isOpen,
  onClose,
  onOpenTexcumar,
  onOpenConfig,
  onOpenNotificationConfig,
  onOpenHistoryConfig,
  onOpenIncidentsLog,
  onLogout,
  canConfigThresholds = false,
  canConfigHistory = false
}) => {
  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'active' : ''}`} onClick={onClose} />
      <div className={`sidebar ${isOpen ? 'active' : ''}`}>
        <div className="sidebar-header">
          <span className="sidebar-title">Menu</span>
          <button className="sidebar-close" onClick={onClose}>x</button>
        </div>
        <div className="sidebar-menu">
          <a
            href="/texcumar"
            className="sidebar-menu-item"
            onClick={(event) => {
              if (onOpenTexcumar) {
                event.preventDefault();
                onOpenTexcumar();
              }
              onClose();
            }}
          >
            <span className="sidebar-menu-icon"><SidebarIcon type="texcumar" /></span>
            <span className="sidebar-menu-text">Monitoreo Texcumar</span>
          </a>

          <div
            className="sidebar-menu-item"
            onClick={() => { onOpenIncidentsLog?.(); onClose(); }}
          >
            <span className="sidebar-menu-icon"><SidebarIcon type="incidents" /></span>
            <span className="sidebar-menu-text">Seguimiento de Alertas</span>
          </div>

          <div
            className={`sidebar-menu-item ${!canConfigThresholds ? 'disabled' : ''}`}
            onClick={() => {
              if (canConfigThresholds) {
                onOpenConfig();
                onClose();
              }
            }}
          >
            <span className="sidebar-menu-icon"><SidebarIcon type="thresholds" /></span>
            <span className="sidebar-menu-text">Umbrales de Sensores</span>
          </div>

          <div
            className={`sidebar-menu-item ${!canConfigThresholds ? 'disabled' : ''}`}
            onClick={() => {
              if (canConfigThresholds) {
                onOpenNotificationConfig();
                onClose();
              }
            }}
          >
            <span className="sidebar-menu-icon"><SidebarIcon type="alerts" /></span>
            <span className="sidebar-menu-text">Frecuencia de Alertas</span>
          </div>

          <div
            className={`sidebar-menu-item ${!canConfigHistory ? 'disabled' : ''}`}
            onClick={() => {
              if (canConfigHistory) {
                onOpenHistoryConfig();
                onClose();
              }
            }}
          >
            <span className="sidebar-menu-icon"><SidebarIcon type="history" /></span>
            <span className="sidebar-menu-text">Opciones Historico</span>
          </div>
        </div>

        <div className="sidebar-footer">
          <button
            className="sidebar-logout-btn"
            onClick={() => {
              onClose();
              if (onLogout) onLogout();
            }}
          >
            <svg
              className="logout-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            <span>Cerrar Sesion</span>
          </button>
        </div>
      </div>
    </>
  );
};
